import React from "react";

const WevoIcon = props => (
    <svg id="wevo_icon" viewBox="0 0 72 42.3">
        <path fill="#66BA4D" d="M50.9 42.3H35.2l-16-31.9h15.7z" />
        <path fill="#66BA4D" d="M35.1 42.3h15.7L72 0H56.3z" />
        <path fill="#59c7fa" d="M15.9 42.3h15.7l15.9-31.9H31.8z" />
        <path fill="#009994" d="M33.4 38.7L41.2 23l-6.3-12.6h-3.1L25.5 23z" />
        <path fill="#00a6e3" d="M31.6 42.3H15.9L0 10.4h15.7z" />
    </svg>
);

export default WevoIcon;



// WEBPACK FOOTER //
// ./src/components/WevoIcon.js